angular.
module("dx.webapp.sorting").
factory("dxSorting", function sortingService(
	DX_STUDENT_SORT_PREDICATE,
	DX_JOB_SORT_PREDICATE,

	dxLocalize
) {
	"use strict";

	var browserLanguage = dxLocalize.browserLanguage ? dxLocalize.browserLanguage : "en";

	function studentSort(students, sortOptions) {
		if (!students || !students.length || !sortOptions) {
			return [];
		}

		var sortedList = students.slice(0);
		var options = JSON.parse(JSON.stringify(sortOptions));

		var defaultSortingPredicates = [
			DX_STUDENT_SORT_PREDICATE.NAME,
			DX_STUDENT_SORT_PREDICATE.FIRST_NAME,
			DX_STUDENT_SORT_PREDICATE.LAST_NAME,
			DX_STUDENT_SORT_PREDICATE.STUDENT_CODE,
			DX_STUDENT_SORT_PREDICATE.EMAIL,
			DX_STUDENT_SORT_PREDICATE.CODE, // studentCode key alternative naming
		];

		if (!students[0].hasOwnProperty(options.predicate)) {
			if (options.predicate === DX_STUDENT_SORT_PREDICATE.STUDENT_CODE && students[0].code) {
				options.predicate = DX_STUDENT_SORT_PREDICATE.CODE;
			} else {
				throw Error("Predicate " + options.predicate + " key not found in student list");
			}
		}

		var isDefaultSorting = false;
		for (var i = 0; i < defaultSortingPredicates.length; i++) {
			if (defaultSortingPredicates[i] === options.predicate) {
				isDefaultSorting = true;
				break;
			}
		}

		if (isDefaultSorting) {
			sortedList.sort(function defaultComparator(s1, s2) {
				return s1[options.predicate].localeCompare(s2[options.predicate], browserLanguage);
			});
		} else if (options.predicate === DX_STUDENT_SORT_PREDICATE.ANONYMOUS_ID) {
			sortedList.sort(function anonNameComparator(s1, s2) {
				return s1[options.predicate] - s2[options.predicate];
			});
		} else if (options.predicate === DX_STUDENT_SORT_PREDICATE.FINAL_GRADE) {
			sortedList.sort(function finalGradeComparator(s1, s2) {
				var student1Grade = s1.finalGrade.grade;
				var student2Grade = s2.finalGrade.grade;

				if (s1.finalGrade.grade.match(/^\d+\.?\d*$/) &&
					s2.finalGrade.grade.match(/^\d+\.?\d*$/)) {
					student1Grade = parseFloat(s1.finalGrade.grade, 10);
					student2Grade = parseFloat(s2.finalGrade.grade, 10);
					return student1Grade - student2Grade;
				}

				// Force to appear after score and free text grades and then sorted by state
				// "ööööööööö" makes it appear after all numbers and letters
				// "99 - state" makes not graded appear before not handed in
				if (!student1Grade) {
					student1Grade = "ööööööööö" + (99 - s1.state);
				}

				if (!student2Grade) {
					student2Grade = "ööööööööö" + (99 - s2.state);
				}
				return student1Grade.localeCompare(student2Grade);
			});
		}
		if (options.reverse) {
			sortedList.reverse();
		}
		return sortedList;
	}

	function jobSort(jobs, sortOptions) {
		if (!jobs || !jobs.length || !sortOptions) {
			return [];
		}

		for (var i = 0; i < jobs.length; i++) {
			if (!jobs[i].hasOwnProperty(sortOptions.predicate)) {
				throw Error("Predicate " + sortOptions.predicate + " key not found in jobs list");
			}
		}

		switch (sortOptions.predicate) {
			case DX_JOB_SORT_PREDICATE.DATE:
				jobs.sort(function sortByDate(a, b) {
					return new Date(a[sortOptions.predicate]) - new Date(b[sortOptions.predicate]);
				});
				break;
			case DX_JOB_SORT_PREDICATE.ID:
			case DX_JOB_SORT_PREDICATE.ORGANIZATION:
			case DX_JOB_SORT_PREDICATE.DESCRIPTION:
				jobs.sort(function sortById(a, b) {
					return parseInt(a[sortOptions.predicate], 10) - parseInt(b[sortOptions.predicate], 10);
				});
				break;
			default:
				jobs.sort(function defaultSort(a, b) {
					return a[sortOptions.predicate].localeCompare(b[sortOptions.predicate], browserLanguage);
				});
		}

		if (sortOptions.reverse) {
			jobs.reverse();
		}
		return jobs;
	}

	function studentSearchSort(students, sortOptions) {
		if (!students || !students.length || !sortOptions) {
			return [];
		}

		for (var i = 0; i < students.length; i++) {
			if (!students[i].student.hasOwnProperty(sortOptions.predicate)) {
				throw Error("Predicate " + sortOptions.predicate + " key not found in student list");
			}
		}

		if (sortOptions.predicate === DX_STUDENT_SORT_PREDICATE.CREATED) {
			students.sort(function dateComparator(s1, s2) {
				return new Date(s1.student[sortOptions.predicate]) - new Date(s2.student[sortOptions.predicate]);
			});
		} else {
			students.sort(function stringComparator(s1, s2) {
				return s1.student[sortOptions.predicate].localeCompare(s2.student[sortOptions.predicate], browserLanguage);
			});
		}
		if (sortOptions.reverse) {
			students.reverse();
		}

		return students;
	}

	function externalToolsSort(tools) {
		if (!tools || !tools.length) {
			return [];
		}
		return tools.sort(function sortAlphabetically(a, b) {
			return a.title.localeCompare(b.title);
		});
	}

	return {
		studentSort: studentSort,
		jobSort: jobSort,
		studentSearchSort: studentSearchSort,
		externalToolsSort: externalToolsSort,
	};
});
